/**
 * Guest Tracking Utility
 * Generates and manages unique guest identifiers for tracking interactions
 */

export const getGuestId = (): string => {
  const storageKey = "guest_id";
  let guestId = localStorage.getItem(storageKey);

  if (!guestId) {
    // Generate a UUID-like identifier
    guestId = `guest-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem(storageKey, guestId);
  }

  return guestId;
};

export const clearGuestId = (): void => {
  localStorage.removeItem("guest_id");
};
